
export default {
  name: 'Button',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    cancelBtn: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'primary',
    },
    border: {
      type: Boolean,
      default: true,
    },
    buttonType: {
      type: String,
      default: 'button',
    },
    slotclass: {
      type: String,
      default: '',
    },
    onboarding: {
      type: Boolean,
      default: false,
    },
    showYPadding: {
      type: Boolean,
      default: true,
    },
    roundedFull: {
      type: Boolean,
      default: false,
    },
    postButton: {
      type: Boolean,
      default: false,
    },
    newPortfolio: {
      type: Boolean,
      default: false,
    },
    deletePortfolio: {
      type: Boolean,
      default: false,
    },
    //added for new design for portfolio page
    //disabled button has grey text and gray background
    disabledGray: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnClass() {
      let res = 'ui-button px-4 focus:outline-none';

      if (this.roundedFull) {
        res += ' rounded-full';
      } else {
        res += ' rounded-xl';
      }

      if (this.showYPadding) {
        res += ' py-2.5';
      }

      if (this.disabled && this.disabledGray) {
        res += ' bg-neutral-4 cursor-not-allowed';
      } else if (this.disabled) {
        res += ' opacity-50 cursor-not-allowed disabled border-neutral-6';
      }

      if (this.newPortfolio) {
        res += ' border-primary-6';
      }

      if (this.loading) {
        res += ' cursor-wait';
      }

      if (this.plain) {
        res += ' icon-white bg-' + this.type;
      }

      if (this.border) {
        if (this.cancelBtn) {
          res += ' border border-neutral-6 text-neutral-13';
        } else res += ' border border-' + this.type;
      }

      if (this.cancelBtn) {
        res += ' border-neutral-6 text-neutral-13';
      }

      return res;
    },
    slotClass() {
      let res = this.slotclass;

      if (this.postButton) {
        res += 'text-fs-13-px text-fw-2 leading-5';
      } else if (this.onboarding) {
        res += 'text-fs-2';
      } else if (this.deletePortfolio) {
        res += 'text-delete-red text-size-2 font-medium leading-4';
      } else {
        res += 'leading-22 text-fw-3 text-fs-2';
      }
      if (this.loading) {
        res += ' opacity-0 block';
      }

      if (this.plain) {
        res += ' text-neutral-1';
      } else {
        res += ' text-' + this.type;
      }

      if (this.disabled && this.disabledGray) {
        res += ' text-neutral-7';
      } else if (this.disabled) {
        res += ' text-neutral-1';
      }

      if (this.newPortfolio) {
        res += ' text-primary-6';
      }

      return res;
    },
  },
};
